import React, {useEffect, useState} from 'react'
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  Spinner,
  Tooltip,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  IconButton,
  Typography
} from '@material-tailwind/react'
import { useSelector } from 'react-redux';
import { formatFloat } from '../../../util/format-data';
import { v4 as uuidv4 } from 'uuid';

import { formatAddress, formatNumberWithCommas }from '../../../util/format-data';
import Op20BuySellCard from './Op20BuySellCard';
import Chart from "react-apexcharts";
import { getOp20CheckTicker, getOp20Trade, createTradeHistory, getOp20TradeByTicker, getTradeActivity } from '../../../util/op20-api';
import { ArrowRightIcon, ArrowLeftIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, FunnelIcon, ArrowLongDownIcon, ArrowLongUpIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { useNavigate } from 'react-router-dom';
import { convertTimestamp } from '../../../util/format-data';

export default function Op20MarketplaceDetail() {
  const { t } = useTranslation();
  const { param } = useParams();
  const navigate = useNavigate();

  const price = useSelector(state => state.price);

  const [loading, setLoading] = useState(false);
  const [currentColor, setCurrentColor] = useState("green");
  const [activityFilter, setActivityFilter] = useState("buy");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [tickerDetail, setTickerDetail] = useState(null);
  const [chartWidth, setChartWidth] = useState(window.innerWidth > 1800 ? 1300 : window.innerWidth - 530);

  const [activityPage, setActivityPage] = useState(1);
  const [activityLimit, setActivityLimit] = useState(10);
  const [activityTotal, setActivityTotal] = useState(0);
  const [activityTotalItem, setActivityTotalItem] = useState(0);
  const [activityDatas, setActivityDatas] = useState([]);

  useEffect(() => {
    fetchActivity(1);
  }, [activityFilter])

  useEffect(() => {
    fetchActivity(activityPage);
  }, [activityPage])

  const fetchActivity = async (page) => {
    setLoading(true);
    const result = await getTradeActivity(param, activityFilter, page, activityLimit);
    setActivityDatas(result.data);
    setActivityTotal(Math.ceil(result.total / activityLimit));
    setActivityTotalItem(result.total);
    setLoading(false);
  }

  const activityNext = () => {
    if (activityPage === activityTotal) return;
    setActivityPage(activityPage + 1);
  };
 
  const activityPrev = () => {
    if (activityPage === 1) return;
    setActivityPage(activityPage - 1);
  };

  const activityDoublePrev = () => {
    setActivityPage(1);
  }

  const activityDoubleNext = () => {
    setActivityPage(activityTotal);
  }


  const [alkanesDetail, setAlkanesDetail] = useState({
    name: "Alkanes1",
    image: "https://cdn.idclub.io/alkanes/293.jpg",
    id: "2:17",
    price: 3.123,
    pricePercent: 12.34,
    volume: 0.999,
    marketCap: 10000,
    trades: 1000,
    symbol: "Alk"
  });

  const [alkanesTokenDetail, setAlkanesTokenDetail] = useState({
    price: 2.8883,
    pricePercent: 8,
    volume: 0.999,
    totalVolume: 0.999,
    marketCap: 10000,
    trades: 1000
  });

  const [timeFilter, setTimeFilter] = useState("ALL");
  const timeFilters = ["ALL", "1m", "1w", "1d"];

  useEffect(() => {
    checkValidTicker();
  }, [param])

  useEffect(() => {
    fetchTickerDetail();
  }, [timeFilter])

  const checkValidTicker = async () => {
    let result = await getOp20CheckTicker(param);
    if (!result.status) {
      navigate('/notfound');
    }
    else {
      await fetchTickerDetail();
    }
  }

  const fetchTickerDetail = async () => {
    setLoading(true);
    let results = await getOp20TradeByTicker(param,timeFilter);
    if (results.status == 'error') {
      await createTradeHistory(param);
      results = await getOp20TradeByTicker( param, timeFilter);
    }
    setTickerDetail(results.data);
    setLoading(false);
  }

  const options = {
    chart: {
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.35,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    tooltip: {
      shared: false,
      marker: {
        show: true,
      },
      custom: function({series, seriesIndex, dataPointIndex, w}) {
        return '<div class="arrow_box">' +
          '<span>' + series[seriesIndex][dataPointIndex] + '</span>' +
          '</div>'
      }
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      offsetX: -10,
    },
    grid: {
      show: true,
      borderColor: '#1F2937',
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  };

  const series = [
    {
      name: "PRODUCT B",
      data: [45, 75, 50, 70, 85, 90, 70, 62],
    }
  ];

  const chartOptions = {
    ...options,
    colors: ["#F7007B"],
  };

  useEffect(() => {
    //handleAlkanesDetail();
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setChartWidth(window.innerWidth > 1800 ? 1300 : window.innerWidth - 530)
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  useEffect(() => {
    if (alkanesTokenDetail.pricePercent > 0) {
      setCurrentColor("green");
    } else {
      setCurrentColor("red");
    }
  }, [alkanesTokenDetail.pricePercent])

  const handleAlkanesDetail = async () => {
    setLoading(true);
    let data = await getAlkanesTopMint({
      query: param,
      page: 1,
      limit: 1,
      order: "idAsc",
      active: null
    });
    setAlkanesDetail(data.data.records[0]);
    setLoading(false);
  }

  const handleTimeFilter = (filter) => {
    setTimeFilter(filter);
  }

  return (
    <div className="text-white mt-[65px] max-w-[1800px] w-full md:px-7 px-2 flex flex-col items-center mb-10 min-h-[600px] gap-3">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-[50%] left-[50%]" color="pink"/> : <></>
      }
      <div className="flex md:flex-row flex-col justify-between gap-6 w-full mt-5">
        <div className="flex flex-col w-full gap-4">
          {
            tickerDetail ?
            <div className="flex flex-col w-full gap-4">
              <div className="flex flex-row gap-1 items-center">
                {
                  tickerDetail.img ?
                  <img src={tickerDetail.img} className="w-[50px] h-[50px] rounded-md"/>
                  :
                  <div className="w-[50px] h-[50px] rounded-md bg-primary flex flex-row items-center justify-center">
                    <div className="text-white font-bold text-[24px]">{tickerDetail.ticker.slice(0, 2)}</div>
                  </div>
                }
                <div className="text-white">
                  <span className="text-lg font-bold">{tickerDetail.ticker}</span>
                </div>
              </div>
              <div className="flex flex-col w-full">
                <div className="flex flex-row justify-between">
                  <div className="flex flex-row gap-1 items-center">
                    <span className="text-2xl font-bold">{tickerDetail.price}</span>
                    <span className="text-2xl font-bold text-gray-400">sats</span>
                  </div>
                  <div className="flex flex-row gap-[1px]">
                    {timeFilters.map((filter, index) => (
                      <div key={index} className={`${timeFilter == filter ? "bg-background2" : "bg-background1"} flex flex-row items-center justify-center text-white text-md font-bold w-[40px] h-[40px] cursor-pointer hover:bg-background2 ${index === 0 ? 'rounded-l-md' : index === timeFilters.length - 1 ? 'rounded-r-md' : ''}`} onClick={() => handleTimeFilter(filter)}>
                        {filter}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="flex flex-row gap-2 items-center">
                  <span>${formatFloat(price.bitcoin * tickerDetail.price / Math.pow(10, 8), 4)}</span>
                  {/* <span className={`flex items-center ${currentColor == "green" ? "text-green-500" : "text-red-500"}`}>
                    {
                      currentColor == "green" ? 
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" class="tw-rotate-180" color="currentColor" width="10" height="10" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.022 1.566a1.13 1.13 0 0 1 1.96 0l6.857 11.667c.457.778-.092 1.767-.98 1.767H1.144c-.889 0-1.437-.99-.98-1.767z"></path></svg> 
                      :
                      <svg stroke={currentColor} fill={currentColor} stroke-width="0" viewBox="0 0 16 16"  color={currentColor} width="10" height="10" xmlns="http://www.w3.org/2000/svg" style={{ transform: "rotate(180deg)" }}><path fill-rule="evenodd" d="M7.022 1.566a1.13 1.13 0 0 1 1.96 0l6.857 11.667c.457.778-.092 1.767-.98 1.767H1.144c-.889 0-1.437-.99-.98-1.767z"></path></svg> 
                    }
                    {alkanesTokenDetail.pricePercent}%
                  </span> */}
                </div>
              </div>
              {/* <div className="flex flex-row rounded-md border-[1px] border-background2 min-h-[100px] w-full">
                <Chart series={series} type="area" height="350" width={chartWidth} options={chartOptions} />
              </div> */}
              <div className="grid md:grid-cols-4 grid-cols-1 gap-2">
                <div className="flex flex-row justify-center items-center bg-background2 rounded-md p-2">
                  <div className="flex flex-col justify-center p-2 gap-1">
                    <div className="font-bold">{t('Total Volume')}</div>
                    <div>
                      <span>{formatFloat(tickerDetail.totalVolume / Math.pow(10, 8), 5)} BTC</span>
                      &nbsp;(<span>${formatFloat(price.bitcoin * tickerDetail.totalVolume / Math.pow(10, 8), 1)}</span>)
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-center items-center bg-background2 rounded-md p-2">
                  <div className="flex flex-col justify-center p-2 gap-1">
                    <div className="font-bold">{t('Volume')} {timeFilter == "ALL" ? "" : `(${timeFilter})`}</div>
                    <div>
                      <span>{formatFloat(tickerDetail.volume / Math.pow(10, 8), 5)} BTC</span>
                      &nbsp;(<span>${formatFloat(price.bitcoin * tickerDetail.volume / Math.pow(10, 8), 1)}</span>)
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-center items-center bg-background2 rounded-md p-2"> 
                  <div className="flex flex-col justify-center p-2 gap-1">
                    <div className="font-bold">{t('Market Cap')} {timeFilter == "ALL" ? "" : `(${timeFilter})`}</div>
                    <div>
                    <span>{formatFloat(tickerDetail.price * tickerDetail.supply / Math.pow(10, 8), 5)} BTC</span>
                      &nbsp;(<span>${formatFloat(price.bitcoin * tickerDetail.price * tickerDetail.supply / Math.pow(10, 8), 1)}</span>)
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-center items-center bg-background2 rounded-md p-2"> 
                  <div className="flex flex-col justify-center p-2 gap-1">
                    <div className="font-bold">{t('Trades')} {timeFilter == "ALL" ? "" : `(${timeFilter})`}</div>
                    <div>{tickerDetail.trades}</div>
                  </div>
                </div>

              </div>
              <div className="md:flex hidden flex-row items-center gap-2">
                <div className="text-white rounded-full bg-background2 px-4 py-1 cursor-pointer">
                  {t('All Activity')}
                </div>
              </div>
            </div>
            : <></>
          }
          <div className="md:flex hidden flex-col gap-2 w-full bg-background2 rounded-md p-4">
            <div className="flex flex-row justify-between">
              <span className="text-white text-xl font-bold">{t('Activity')} ({activityTotalItem})</span>
              <div>
              <Tooltip content={t('Filter')}>
                <Menu placement="bottom-end">
                  <MenuHandler>
                    <div className="border-borderColor border-solid border-[1px] rounded-md p-[6px] cursor-pointer"><FunnelIcon strokeWidth={2} className="h-6 w-6" /></div>
                  </MenuHandler>
                  <MenuList className="bg-black border-black text-white">
                    <MenuItem onClick={() => setActivityFilter('buy')}>{t('Sale')}</MenuItem>
                    <MenuItem onClick={() => setActivityFilter('list')}>{t('List')}</MenuItem>
                    <MenuItem onClick={() => setActivityFilter('delist')}>{t('Cancel')}</MenuItem>
                  </MenuList>
                </Menu>
              </Tooltip>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex flex-row text-white font-bold border-b-[1px] border-background1 px-2">
                <div className="w-[15%]">{t('Time')}</div>
                <div className="w-[15%]">{t('Type')}</div>
                <div className="w-[15%]">{t('Amount')}</div>
                <div className="w-[20%]">{t('Price')} (sats)</div>
                <div className="w-[20%]">{t('Total Price')}</div>
                <div className="w-[15%]">{t('Address')}</div>
              </div>
              {
                activityDatas.map((item, index) => (
                  <div key={uuidv4()} className="flex flex-row text-white py-2 border-b-[1px] border-background1 items-center hover:bg-background px-2">
                    <div className="w-[15%] flex flex-row items-center gap-1">
                      <span>{item.updatedAt ? convertTimestamp(item.updatedAt) : convertTimestamp(item.createdAt)}</span>
                      {
                        item.txId ?
                        <svg onClick = {() => window.open(`https://mempool.space/tx/${item.txId}`, "_blank")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" className="tw-opacity-60 cursor-pointer" color="rgb(var(--textColor-primary))" width="18" height="18" size="18"><path d="M13.5 6.5L13.4994 2.50062L9.5 2.5M8.5 7.5L13.5 2.5M11.5 8.5V13C11.5 13.1326 11.4473 13.2598 11.3536 13.3536C11.2598 13.4473 11.1326 13.5 11 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V5C2.5 4.86739 2.55268 4.74021 2.64645 4.64645C2.74021 4.55268 2.86739 4.5 3 4.5H7.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                        :
                        <></>
                      }
                    </div>
                    <div className="w-[15%]">{activityFilter}</div>
                    <div className="w-[15%]">{formatNumberWithCommas(item.amount)}</div>
                    <div className="w-[20%] flex flex-col">
                      <span>{item.unitPrice} sats</span>
                      <span className="text-gray-400 text-sm">${formatFloat(price.bitcoin * item.unitPrice / Math.pow(10, 8), 4)}</span>
                    </div>
                    <div className="w-[20%] flex flex-col">
                      <span>{formatFloat(item.totalPrice / Math.pow(10, 8), 5)} BTC</span>
                      <span className="text-gray-400 text-sm">${formatFloat(price.bitcoin * item.totalPrice / Math.pow(10, 8), 2)}</span>
                    </div>
                    <div className="w-[15%]">{formatAddress(item.ownerAddress)}</div>
                  </div>
                ))
              }
              {
                activityTotal > 1 ? 
                <div className="flex flex-row items-center justify-center gap-8 mt-5">
                  <div className="flex flex-row items-center gap-2">
                    <IconButton
                      size="sm"
                      variant="outlined"
                      onClick={activityDoublePrev}
                      disabled={activityPage === 1}
                      className="bg-primary hover:bg-primary-hover"
                    >
                      <ChevronDoubleLeftIcon strokeWidth={2} className="h-4 w-4" />
                    </IconButton>
                    <IconButton
                      size="sm"
                      variant="outlined"
                      onClick={activityPrev}
                      disabled={activityPage === 1}
                      className="bg-primary hover:bg-primary-hover"
                    >
                      <ChevronLeftIcon strokeWidth={2} className="h-4 w-4" />
                    </IconButton>
                  </div>
                  <Typography color="white" className="font-normal">
                    {t('Page')} <strong className="text-primary">{activityPage}</strong> of{" "}
                    <strong className="text-primary">{activityTotal}</strong>
                  </Typography>
                  <div className="flex flex-row items-center gap-2">
                    <IconButton
                      size="sm"
                      variant="outlined"
                      onClick={activityNext}
                      disabled={activityPage === activityTotal}
                      className="bg-primary hover:bg-primary-hover"
                    >
                      <ChevronRightIcon strokeWidth={2} className="h-4 w-4" />
                    </IconButton>
                    <IconButton
                      size="sm"
                      variant="outlined"
                      onClick={activityDoubleNext}
                      disabled={activityPage === activityTotal}
                      className="bg-primary hover:bg-primary-hover"
                    >
                      <ChevronDoubleRightIcon strokeWidth={2} className="h-4 w-4" />
                    </IconButton>
                  </div>
                </div>
                :
                <></>
              }
            </div>
          </div>
        </div>
        <Op20BuySellCard ticker = {param}/>
      </div>
    </div>
  )
}
